/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sso_No_OrganizationsInputs */



/**
* | output |
* | --- |
* | "No Organizations Found" |
*
* @param {Auth_Sso_No_OrganizationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_no_organizations = /** @type {((inputs?: Auth_Sso_No_OrganizationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_No_OrganizationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Organisationen gefunden")
	return /** @type {LocalizedString} */ ("No Organizations Found")
});